import { ICellRendererParams } from 'ag-grid-community'
import { useEffect, useState } from 'react'

interface Props extends ICellRendererParams {
  value: string
}

/**
 * 名称列のセルレンダラー
 * プリセット以外で名称が空の場合に赤い背景を表示
 */
export const NameCellRenderer = (props: Props) => {
  const { value, data } = props
  const [hasError, setHasError] = useState(false)

  useEffect(() => {
    // プリセット以外で名称が空の場合はエラー
    const error = !data?.isPreset && (!value || value.trim() === '')
    setHasError(error)
  }, [value, data])

  return (
    <div
      className={'sevend-ag-cell'}
      style={{ backgroundColor: hasError ? '#FADBD8' : undefined }}
    >
      {value}
    </div>
  )
}
